import CitySelector from "../cityselector/CitySelector";
import { ICity, ISection } from "../../model/B2CInfo";
import { trackGoal } from "../../../helpers/tracker";

interface IMenuRowProps {
    city: ICity
    onSelected: (city: ICity) => void
}

export default function MenuRow(props: IMenuRowProps) {
    const menuItems = props.city.sections.flatMap((item) => {
        if (!item.show_in_header) {
            return null;
        }
        return <MenuItem key={item.id} item={item} />;
    });

    return <div className="PromoItemRow">
        <CitySelector city={props.city} onSelected={props.onSelected} />
        <ReferralMenuItem/>
        {menuItems}
        <a className="DownloadDriveButton" onClick={(e) => {
            window.document
                .querySelector("#app_promo")
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
            trackGoal(`tap_download`);
        }}>Скачать</a>
    </div>
}

function MenuItem({ item }: { item: ISection }) {
    function handleClick() {
        window.document
            .querySelector(`#${item.id}`)
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
        trackGoal(`tap_${item.id}`);
    }

    return <a className="PromoItem" onClick={handleClick}>
        {item.name}
    </a>;
}

function ReferralMenuItem() {
    function handleClick() {
        window.open("https://yandex.ru/drive/referral/", "_self");
    }

    return <a className="ReferralPromoItem" onClick={handleClick}>
        Баллы за друзей
    </a>;
}